import { render, staticRenderFns } from "./GroupTypeBranch.vue?vue&type=template&id=55c96584&scoped=true&"
import script from "./GroupTypeBranch.vue?vue&type=script&lang=ts&"
export * from "./GroupTypeBranch.vue?vue&type=script&lang=ts&"
import style0 from "./GroupTypeBranch.vue?vue&type=style&index=0&id=55c96584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c96584",
  null
  
)

export default component.exports